import { useEffect, useMemo, useState } from "react";
import * as React from "react";
// Font Awesome icons
import { useParams, useLocation, useHistory } from "react-router-dom";
import DashboardTab from "../components/DashboardTab";
import ClinicalSwallowEvaluation from "../components/ClinicalSwallowEvaluation";
import DietDepartmentPage from "../features/Dietetics/pages/DietPatientspage";
import ICDExisting from "../components/ICDExisting";
import PatientsToDepartments from "../components/PatientsToDepartments";
import PatientsByDepartment from "../components/PatientsByDepartment";
import VitalsTab from "../components/VitalsTab";
import AssessmentsPanel from "../components/AssessmentsPanel";
import DepartmentPage from "../features/PT/pages/Patientspage";
import AudiologyDepartmentPage from "../features/Audiology/pages/AudioDashboard";
import PatientRegister from "../features/CustomerService/pages/PatientRegistration"
import BASEASSESSMENT from "../components/BASEASSESSMENT";
import RAPTab from "../components/RAPTab";
import TaskPerformanceSimulationTab from "../components/TaskPerformanceSimulationTab";
import AssessmentEncounterTab from "../components/AssessmentEncounterTab";
import NewAssessmentTab from "../components/NewAssessmentTab";
import MultiSelect from "../components/MultiSelect";
import SidebarNav from "../components/SidebarNav";
import DocumentsTab from "../components/DocumentsTab";
import PablotList from "../components/Pablot"
import ICFTab from "../components/ICFTab";
import ICDNormal from "../components/ICDNormal";
import ICFNormal from "../components/ICFNormal";
import PharmacyDetailsCaptureTab from "../components/PharmacyDetailsCaptureTab";
import ICHITab from "../components/ICHITab";
import ICDInfinite from "../components/ICDInfinite";
import RAPFinal from "../components/RAPFinal"
import RAPCaseDashboardView from "../components/RAPCaseDashboardView";
import ICDAD from "../components/ICDAssignDoctor";
import "chart.js/auto";
import DoctorsDepartmentPage from "../features/Doctors/pages/DoctorsPatientspage";
import AuditTrailTab from "../components/AuditTrailTab";
import StyleBlock from "../components/StyleBlock";
import AsyncPatientSearch from "../components/AsyncPatientSearch";
import EmploymentDetailsForm from "../components/EmploymentDetailsForm";
import FinancialDetailsForm from "../components/FinancialDetailsForm";
import PersonalDetailsForm from "../components/PersonalDetailsForm";
import PatientSummary from "../components/PatientSummary";
import NurseBaseAssessment from "../components/NurseBaseAssessment";
import GasGoalsNATab from "../components/GasGoalsNATab";
import RowCard from "../components/RowCard";
import { sx } from "../components/RowCard";
import InvestigationsChecklist from "../components/InvestigationsChecklist";
import BookAppointmentTab from "../components/BookAppointmentTab";
import GasGoalsTab from "../components/GasGoalsTab";
import SpeechPatients from "../features/SpeechandLanguage/SpeechandlanguagePatients";
import GlobalVitalsOverlay from "../components/GlobalVitalsOverlay";
import SpeechAndLanguage from "../features/SpeechandLanguage/SpeechandlanguageDashboard"
import OptometryPatients from "../features/Optometry/OptometryPatients";
import DieteticsPatients from "../features/Dietetics/DieteticsPatients";
import PsychologyPatients from "../features/Psychology/PsychologyPatients";
import ProstheticsPatients from "../features/Prosthetics & Orthotics/ProstheticsAndOrthoticsPatients";
import NursingDepartmentPage from "../features/Nursing/pages/NursingPatientspage";
import OtDepartmentPage from "../features/OT/pages/Patientspage";
import WandRDepartmentPage from "../features/VocationalRehab/pages/Patientspage";
import AudiologyPatients from "../features/Audiology/AudiologyPatients";
import GenericDepartmentDashboard from "../features/common/GenericDepartmentDashboard";
import RAP from "../features/Rap/";


export default function App() {
  const username = localStorage.getItem("username") || "";
  const userRole = localStorage.getItem("userRole") || "";
  const [tab, setTab] = useState("");

  const { mode } = useParams();
  const location  = useLocation();
  const history   = useHistory();

  /* ── Department tab → URL slug ── */
  const TAB_TO_SLUG = {
    "Audiology":               "audiology",
    "Physiotherapy":           "physiotherapy",
    "Occupational Therapy":    "occupational-therapy",
    "Psychology":              "psychology",
    "Optometry":               "optometry",
    "Nursing":                 "nursing",
    "Dietetics":               "dietetics",
    "Speech & Language Therapy": "speech",
    "Prosthetics & Orthotics": "prosthetics",
    "Work & Vocational Rehab": "vocational",
    "Doctor":                  "doctor",
    "RAPFINAL":                "rap-case",
    "RAP":                     "rap",
  };

  /* Wraps setTab — also updates the URL when switching to a department */
  const navigateToTab = (newTab) => {
    setTab(newTab);
    const slug = TAB_TO_SLUG[newTab];
    if (slug) {
      history.replace(`/menu/${slug}`);
    } else {
      history.replace("/menu");
    }
  };

  const [userType, setUserType] = useState("");
  const [icdCode, setIcdCode] = useState(""); // deepest ICD from ICD tab
  const [showVitals, setShowVitals] = useState(false);
  const [vitalsPatient, setVitalsPatient] = useState(null);
  const [icdPath, setIcdPath] = useState([]); // [{ depth, table, key, label }]
  const [financialState, setFinancialState] = useState(null);
  const [employmentState, setEmploymentState] = useState(null);
  const [icfCode, setIcfCode] = useState(""); // optional single ICF child context for ICHI
  // inside App()
  const [soap, setSoap] = useState({}); // Assessment & Encounter (SOAP)

  const [tps, setTps] = useState({}); // TPS
  // RAP state removed (unused)
  const [rapPercent, setRapPercent] = useState(0); // show "60%" in left rail
  const handleUserSelection = (type) => {
    setUserType(type);
  };
  useEffect(() => {
    if (mode === "new") {
      handleUserSelection("NEW_USER");
    } else if (mode === "existing") {
      handleUserSelection("EXISTING_USER");
    }
    // if mode is undefined, your normal landing stays
  }, [mode]);

  /* ── Deep-link: set department tab from location state ── */
  useEffect(() => {
    const initialTab = location?.state?.initialTab;
    if (initialTab) {
      setTab(initialTab);
    }
  }, [location?.state?.initialTab]);

  /* ── Direct URL hit: /menu/<slug> → set the correct tab ── */
  const SLUG_TO_TAB = {
    "audiology":            "Audiology",
    "physiotherapy":        "Physiotherapy",
    "occupational-therapy": "Occupational Therapy",
    "psychology":           "Psychology",
    "optometry":            "Optometry",
    "nursing":              "Nursing",
    "dietetics":            "Dietetics",
    "speech":               "Speech & Language Therapy",
    "prosthetics":          "Prosthetics & Orthotics",
    "vocational":           "Work & Vocational Rehab",
    "doctor":               "Doctor",
    "medical-assistant":    "Nursing",
    "rap-case":             "RAPFINAL",
    "rap":                  "RAP",
  };
  useEffect(() => {
    if (mode && SLUG_TO_TAB[mode]) {
      setTab(SLUG_TO_TAB[mode]);
    }
  }, [mode]);

  // Patient controlled form state in App (for summary & persistence)
  const [patient, setPatient] = useState({
    patient_id: "",
    patient_name: "",
    reg_day: "",
    reg_month: "",
    reg_year: "",
    dob_day: "",
    dob_month: "",
    dob_year: "",
    gender: "",
    marital: "",
    nationality: "",
    occupation: "",
  });
  const [patients, setPatients] = useState([]);
  
  function updatePatientInMainList(updatedPatient) {
    setPatients(prev =>
      prev.map(p => p.id === updatedPatient.id ? updatedPatient : p)
    );
  }


  // Summaries emitted from sub-tabs
  const [icfSummary, setIcfSummary] = useState([]); // array of normalized records
  const [ichiSummary, setIchiSummary] = useState({
    selected: [],
    modalities: [],
    note: "",
  });
  // Compute RAP % centrally and show in left rail


  const [gasSummary, setGasSummary] = useState([]);
  // If your ICF tab already returns a summary, derive the selected ICF child codes from it.
  // --- RAP + Audit (layout only) ---
  const [rapData, setRapData] = useState({
    checks: {
      tps: true,
      workplace: false,
      family: true,
      med: false,
      vocational: false,
      employer: false,
    },
    start_date: "",
    duration_weeks: 4,
    placement: "Light assembly / QC",
    restrictions: "No lifting >10kg; avoid ladder work; adjustable workstation",
  });
  useEffect(() => {
    const total = 6;
    const done = Object.values(rapData.checks || {}).filter(Boolean).length;
    setRapPercent(Math.round((done / total) * 100));
  }, [rapData]);
  const [auditItems, setAuditItems] = useState([]); // [{date:'YYYY-MM-DD', text:'...'}]
  const addAudit = (text) =>
    setAuditItems((prev) => [
      { date: new Date().toISOString().slice(0, 10), text },
      ...prev,
    ]);

  // Adapt the selector to your icfSummary shape.
  const icfChildren = useMemo(() => {
    // accept either array from ICFTab, or an object that holds an array in `.selected`
    const rows = Array.isArray(icfSummary)
      ? icfSummary
      : Array.isArray(icfSummary?.selected)
        ? icfSummary.selected
        : [];

    // map both possible key names & make unique
    const codes = rows
      .map((r) => r.child_icf || r.icf_child_code)
      .filter(Boolean);

    return Array.from(new Set(codes));
  }, [icfSummary]);

  // Save all key selections for the current patient
  // Put this near where you have access to `form` (personal),
  // `financialState`, `employmentState`, and your ICD/ICF/ICHI/GAS state.
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  // Function to toggle the profile dropdown
  const toggleProfileMenu = () => {
    setShowProfileMenu((prev) => !prev);
  };
          function addPatient(p) {
  setPatients(prev => [...prev, p]);
}
  
useEffect(() => {
  window.openVitals = (patient) => {
    setVitalsPatient(patient);
    setShowVitals(true);
  };

    return () => {
      delete window.openVitals;
    };
  }, []);

  return (
    <>
      <StyleBlock />
      {/* Home interface when no user is selected */}

      <div className="page page--app-shell">
        {/* Left rail */}
        <SidebarNav
          tab={tab}
          setTab={navigateToTab}
          userType={userType}
          icdCode={icdCode}
          icfCode={icfCode}
          rapPercent={rapPercent}
          username={username}
          userRole={userRole}
        />

        {/* Main area */}
        <main className="main min-w-0 flex-1 pt-14 md:pt-0">
          {/* /* Global toolbar */}





          <MainContent
            key={tab}
            tab={tab}
            addPatient={addPatient}
            patients={patients}
            updatePatientInMainList={updatePatientInMainList}
          />


          {/* PERSONAL */}
          {/* DASHBOARD */}

          <section style={{ display: tab === "DASHBOARD" ? "block" : "none" }}>
            <DashboardTab
              patient={patient}
              icdPath={icdPath}
              icdCode={icdCode}
              icfSummary={icfSummary}
              ichiSummary={ichiSummary}
              rapPercent={rapPercent}
              rapData={rapData}
            />
          </section>

          <GlobalVitalsOverlay
            open={showVitals}
            patient={vitalsPatient}
            onClose={() => setShowVitals(false)}
          />

          <section style={{ display: tab === "ICD_EXISTING" ? "block" : "none" }}>
            <ICDExisting patientId={patient.patient_id} />
          </section>

          <section style={{ display: tab === "NurseBaseAssessment" ? "block" : "none" }}>
            <NurseBaseAssessment />
          </section>

          <section style={{ display: tab === "ClinicalSwallowEvaluation" ? "block" : "none" }}>
            <ClinicalSwallowEvaluation />
          </section>

          <section style={{ display: tab === "ICDNormal" ? "block" : "none" }}>
            <ICDNormal
              onDeepestICDChange={(code) => { setIcdCode(code); setIcfCode(""); }}
              onPathChange={setIcdPath}
            />
          </section>

          <section style={{ display: tab === "ICFNormal" ? "block" : "none" }}>
            <ICFNormal
              icdCode={icdCode}
              onSummaryChange={setIcfSummary}
              onSelectICF={setIcfCode}   // keep a single ICF child context for ICHI (optional)
            />
          </section>
          <section style={{ display: tab === "PTD" ? "block" : "none" }}>
            <PatientsToDepartments patientId={patient.patient_id} setTab={setTab} />
          </section>

          <section style={{ display: tab === "BASEASSESSMENT" ? "block" : "none" }}>
            <BASEASSESSMENT />
          </section>

          <section style={{ display: tab === "PatientsByDepartment" ? "block" : "none" }}>
            <PatientsByDepartment setTab={setTab} department="Neurophysics" />
          </section>
          <section style={{ display: tab === "NEWPATIENTS" ? "block" : "none" }}>
            {/* Only the patient list shown here */}
            <div style={{ padding: 16 }}>
              <PablotList
                onSelectPatient={(pid, icd) => {
                  setPatient((p) => ({ ...p, patient_id: pid }));
                  setIcdCode(icd);
                  setTab("ICF"); // ✅ after clicking "Edit", go directly to ICF tab
                }}
              />
            </div>
          </section>


          <section style={{ display: tab === "PERSONAL" ? "block" : "none" }}>
            <PersonalDetailsForm
              value={patient}
              onChange={setPatient}
              onFinancialChange={setFinancialState}
              onEmploymentChange={setEmploymentState}
            />
          </section>

          <section style={{ display: tab === "VITALS" ? "block" : "none" }}>
            <VitalsTab patientId={patient?.id} onSaved={() => { }} />
          </section>
          {/* ICD */}
          <section style={{ display: tab === "ICD" ? "block" : "none" }}>
            <ICDInfinite
              onDeepestICDChange={(code) => {
                setIcdCode(code);
                setIcfCode("");
              }}
              onPathChange={setIcdPath}
            />
          </section>
          <section style={{ display: tab === "ICDAD" ? "block" : "none" }}>
            <ICDAD
              onDeepestICDChange={(code) => {
                setIcdCode(code);
                setIcfCode("");

              }}
              onPathChange={setIcdPath}
            />
          </section>

          {/* ICF */}
          <section style={{ display: tab === "ICF" ? "block" : "none" }}>
            <ICFTab
              patientId={patient.patient_id}  // ✅ Use existing patient state
              icdCode={icdCode}
              onSummaryChange={setIcfSummary}
              onSelectICF={setIcfCode}
            />
          </section>

          {/* ICHI */}
          <section style={{ display: tab === "ICHI" ? "block" : "none" }}>
            <ICHITab
              icdCode={icdCode}
              icfCode={icfCode}
              onSummaryChange={setIchiSummary}
            />
          </section>
          {/* GAS */}
          <section style={{ display: tab === "GAS" ? "block" : "none" }}>
            <GasGoalsTab
              icfChildren={icfChildren}
              onSummaryChange={setGasSummary}
            />
          </section>
          <section
            style={{ display: tab === "BOOK_APPOINTMENT" ? "block" : "none" }}
          >
            <BookAppointmentTab patient={patient} />
          </section>
          <section
            style={{
              display: tab === "ORDER_INVESTIGATIONS" ? "block" : "none",
            }}
          >
            <InvestigationsChecklist
              variant="inline"
              patient={{ id: "PT-0001", name: "Jhon Doe" }}
              // initialRows={[{ item: "Lumbar spine X-ray (AP/Lateral)", type: "Radiology", test: "X-ray" }]}
              onSave={(rows) => console.log("Saved rows:", rows)}
            />
          </section>
          <section style={{ display: tab === "GASNA" ? "block" : "none" }}>
            <GasGoalsNATab
              icfChildren={icfChildren}
              onSummaryChange={setGasSummary}
            />
          </section>

          <section
            style={{ display: tab === "NEWASSESSMENT" ? "block" : "none" }}
          >
            <NewAssessmentTab />
          </section>
          <section
            style={{ display: tab === "RAPFINAL" || mode === "rap-case" ? "block" : "none" }}
          >
            <RAPCaseDashboardView />
          </section>
          {/* SUMMARY */}
          <section style={{ display: tab === "SUMMARY" ? "block" : "none" }}>
            <PatientSummary
              patient={patient}
              icdPath={icdPath}
              icdCode={icdCode}
              icfSummary={icfSummary}
              ichiSummary={ichiSummary}
              gasSummary={gasSummary}
            />
          </section>
          {/* Assessment & Encounter (SOAP) */}
          <section style={{ display: tab === "ASSESSMENT" ? "block" : "none" }}>
            <AssessmentEncounterTab
              patientId={patient.patient_id}
              value={soap}
              onChange={setSoap}
              onSaved={() =>
                addAudit("SOAP saved — Assessment/Encounter updated")
              }
              /* NEW: options for the goals table */
              icfOptions={(icfSummary || []).map((x) => ({
                value: x.child_icf,
                label:
                  `${x.child_icf} — ${x.child_name}` +
                  (Number.isFinite(x.score) ? ` (GAS ${x.score})` : ""),
              }))}
              ichiOptions={
                Array.isArray(ichiSummary?.selected)
                  ? ichiSummary.selected.map((s) => ({
                    value: s.ichi_code,
                    label: `${s.ichi_code} — ${s.ichi_name}`,
                  }))
                  : []
              }
              icdContext={icdCode || ""}
            />
          </section>

          {/* Task Performance Simulation (TPS) */}
          <section style={{ display: tab === "TPS" ? "block" : "none" }}>
            <TaskPerformanceSimulationTab
              patientId={patient.patient_id}
              value={tps}
              onChange={setTps}
              onSaved={() =>
                addAudit("TPS saved — Task performance data updated")
              }
            />
          </section>
          <section style={{ display: tab === "PHARMACY" ? "block" : "none" }}>
            <PharmacyDetailsCaptureTab />
          </section>
          {/* Documents */}
          <section style={{ display: tab === "DOCUMENTS" ? "block" : "none" }}>
            <DocumentsTab patientId={patient.patient_id} />
          </section>

          {/* Audit Trail */}
          <section style={{ display: tab === "AUDIT" ? "block" : "none" }}>
            <AuditTrailTab items={auditItems} />
          </section>

          {/* {showAllergy && (
            <div
              style={{
                position: "fixed",
                left: 16,
                right: 16,
                bottom: 16,
                zIndex: 9999,
                display: "flex",
                justifyContent: "center",
                pointerEvents: "none",
              }}
            >
              <div
                style={{
                  pointerEvents: "auto",
                  background: "#fff",
                  border: "1px solid #fca5a5",
                  borderRadius: 12,
                  padding: "14px 18px",
                  boxShadow: "0 12px 30px rgba(0,0,0,.12)",
                  maxWidth: 720,
                  width: "100%",
                }}
              >
                <h2
                  style={{
                    margin: 0,
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#991b1b",
                  }}
                >
                  Allergic reactions
                </h2>
                <ul style={{ margin: "6px 0 0", paddingLeft: 18 }}>
                  <li>Allergic to brinjal</li>
                  <li>Allergic to riboflavin drug</li>
                </ul>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 8,
                  }}
                >
                  <button className="btn" onClick={() => setShowAllergy(false)}>
                    Dismiss
                  </button>
                </div>
              </div>
            </div>
          )} */}
        </main>
      </div>
    </>
  );
}

export function Field({ label, children }) {
  return (
    <label style={sx.field}>
      <span style={sx.fieldLabel}>{label}</span>
      {children}
    </label>
  );
}

/* ---------- helpers & styles ---------- */
export function guid() {
  return crypto.randomUUID
    ? crypto.randomUUID()
    : String(Date.now() + Math.random());
}
export function csvEscape(v) {
  const s = (v ?? "").toString().replace(/"/g, '""');
  return `"${s}"`;
}
export function downloadBlob(content, filename, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}



export function MainContent({

  tab,
  addPatient,
  patients,
  updatePatientInMainList
}) {

  switch (tab) {
    case "Customer Service":
      return <PatientRegister addPatient={addPatient} />;

    case "Physiotherapy":
      return <GenericDepartmentDashboard departmentName="Physiotherapy Department" patients={patients} updatePatientInMainList={updatePatientInMainList} />;

    case "Integrated Rehab":
      return <GenericDepartmentDashboard departmentName="Integrated Rehab Department" patients={patients} updatePatientInMainList={updatePatientInMainList} />;

    case "Occupational Therapy":
      return <GenericDepartmentDashboard departmentName="Occupational Therapy Department" patients={patients} updatePatientInMainList={updatePatientInMainList} />;

    case "Work & Vocational Rehab":
      return <GenericDepartmentDashboard departmentName="Work & Vocational Rehab Department" patients={patients} updatePatientInMainList={updatePatientInMainList} />;

    case "Psychology":
      return <GenericDepartmentDashboard departmentName="Psychology Department" patients={patients} PatientsComponent={PsychologyPatients} updatePatientInMainList={updatePatientInMainList} />;

    case "Optometry":
      return <GenericDepartmentDashboard departmentName="Optometry Department" patients={patients} PatientsComponent={OptometryPatients} updatePatientInMainList={updatePatientInMainList} />;

    case "Prosthetics & Orthotics":
      return <GenericDepartmentDashboard departmentName="Prosthetics & Orthotics Department" patients={patients} updatePatientInMainList={updatePatientInMainList} />;

    case "Speech & Language Therapy":
      return <GenericDepartmentDashboard departmentName="Speech & Language Therapy Department" patients={patients} PatientsComponent={SpeechPatients} updatePatientInMainList={updatePatientInMainList} />;

    case "Dietetics":
      return <GenericDepartmentDashboard departmentName="Dietetics Department" patients={patients} PatientsComponent={DieteticsPatients} updatePatientInMainList={updatePatientInMainList} />;

    case "Audiology":
      return <GenericDepartmentDashboard departmentName="Audiology Department" patients={patients} PatientsComponent={AudiologyPatients} updatePatientInMainList={updatePatientInMainList} />;

    case "Doctor":
      return <GenericDepartmentDashboard departmentName="Doctor Department" patients={patients} updatePatientInMainList={updatePatientInMainList} />;

    case "Nursing":
      return <GenericDepartmentDashboard departmentName="Nursing & MA Department" patients={patients} updatePatientInMainList={updatePatientInMainList} />;

    case "RAP":
      return <RAP title="RAP" />
      
    default:
      return <PatientRegister addPatient={addPatient} />;
  }
}


<GasGoalsNATab />;

/* ---------------- Patient Summary ---------------- */
<PatientSummary />;

/* ---------------- Personal details (New/Existing + Save + History) ---------------- */
// ---------------- PersonalDetailsForm ----------------
<PersonalDetailsForm />;

// ---------------- FinancialDetailsForm ----------------
<FinancialDetailsForm />;

// ---------------- EmploymentDetailsForm ----------------
<EmploymentDetailsForm />;

<AsyncPatientSearch />;

/* ---------------- Reusable MultiSelect ---------------- */
<MultiSelect />;

/* ---------------- Common Rows (re-exported; defined in FormLayout to avoid circular imports) ---------------- */
export { Row, DateTriple } from "../components/FormLayout";

/* ---------------- Styles ---------------- */
<StyleBlock />;
